//https://www.w3schools.com/howto/howto_js_slideshow.asp

'use strict';

var indic = document.querySelector('.indic');
var slideIndex = 1;
showSlides(slideIndex);

function plusSlides(n) {
  showSlides(slideIndex += n);
}

function showSlides(n) {
  var i;
  var slides = document.querySelectorAll(".content");
  if (n > slides.length) {slideIndex = 1}    
  if (n < 1) {slideIndex = slides.length}

  slides[slideIndex-1].classList.add("anim");

  for (i = 0; i < slides.length; i++) {
      slides[i].classList.add("hide");  
  }
  slides[slideIndex-1].classList.remove("hide");  
  indic.innerHTML = slideIndex;
}



//Afficher les informations

const moreLinks = document.querySelectorAll(".more");
const areaDetails = document.querySelector('.details');
const sectionDetails = document.querySelector('.section__details');

//Information sur le site
const url = "../data.json";
let cache = [];

  for (let projetLink of moreLinks){
    projetLink.addEventListener("click", (e) => {
      let idProjet = e.currentTarget.getAttribute("data-more");

      fetch(url)
      .then(response => response.json())
      .then(json => {
      
          cache = json.information;
      
          let result = cache.filter(element => element.id == idProjet);
      
      
          let projetUrl = "http://juliettemartin-cocher.be/projets/"+result[0].link;
      
          areaDetails.innerHTML = "";  
          
          let divDetails = document.createElement("div");
          divDetails.innerHTML = `
      
          <div class="container">
            <div class="screen">
              <img  src="../assets/images/${result[0].img}"
                    srcset="../assets/images/${result[0].img2x} 2x"
                    alt="capture d'écran du site de ${result[0].title}"
                    class="screen">
            </div>
            <div class="col__details">
              <a href="${projetUrl}"><h2 class="title title__details">${result[0].title}</h2></a>
              <ul class="list">
                <li class="list__el">${result[0].info1}</li>
                <li class="list__el">${result[0].info2}</li>
                <li class="list__el">${result[0].info3}</li>
                <li class="list__el">${result[0].info4}</li>
              </ul>
              <a class="btn btn__details" href="${projetUrl}">Accès au projet</a>
            </div>
          </div>
          `;
      
          areaDetails.appendChild(divDetails);
      });
      sectionDetails.classList.remove('hide');
      sectionDetails.classList.remove('animClose');
      sectionDetails.classList.add('animDetails');
    });
  }


  const close = document.querySelector('.close');
  close.addEventListener('click', (e) => {
    sectionDetails.classList.add('animClose');
    sectionDetails.classList.remove('animDetails');
    sectionDetails.addEventListener('animationend', (e) =>{
      if(sectionDetails.classList.contains('animClose')){
        sectionDetails.classList.add('hide');
      }
    })
  });